import React from "react";
import PropTypes from "prop-types";

import theme from "@/foundation/Theme";

import { StyledBadge } from "./style";

function Badge({ type, variant }) {
  const badgeData = {
    featured: {
      textColor: theme.colors.white,
      backgroundColor: theme.colorsV2.shyft.purple_text,
    },
    new: {
      textColor: theme.colors.white,
      backgroundColor: theme.colorsV2.shyft.orange,
    },
    upcoming: {
      textColor: theme.colorsV2.gray.shade_600,
      backgroundColor: theme.colorsV2.gray.shade_25,
    },
  };

  const badge = badgeData[type?.toLowerCase()];

  return (
    <StyledBadge
      variant={variant}
      color={badge.textColor}
      bgColor={badge.backgroundColor}
    >
      {type}
    </StyledBadge>
  );
}

Badge.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
};

Badge.defaultProps = {
  type: "upcoming",
  variant: "label3",
};

export default Badge;
